const DryCargo = () => {
  return (
    <div>
  
      <div className="flex flex-col justify-center items-center">
      <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
        <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">
        
          <div className="flex flex-col justify-center">
            <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
              Dry Cargo
            </h1>
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
              Be it coal, clothing, mangoes, or computers, dry cargo covers an extensive range of commodities. 
              TCS dry cargo services have been developed to make sure that your containerised cargo is transported 
              efficiently. We are fully compliant to international standards e.g. DGR and ADR and have the know-how 
              to safely move anything from paper and scrap metal, to hazardous material, perishable as well as 
              rare and precious cargo.
            </p>
          </div>
          <div className="flex-1 flex flex-col justify-center lg:mt-[0rem] mt-[1rem]">
              <img src="/overland/Dry-Cargo-Insid.jpg" alt="" className="max-w-[100%] rounded-md"/>
          </div>
          </div>
      
      </div>
    </div>
  );
};
  
export default DryCargo;
  